import httpService from '@Utils/httpService';

const baseUrl = 'api/AMIS';
const inspectionUrl = 'api/forge/inspections';

export default {
  get(params) {
    return httpService.get({
      url: `${baseUrl}/typeHead`,
      params,
    });
  },
  getById(id, facilityId = null) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
      ...(facilityId ? { headers: { 'X-Facility-Id': facilityId } } : {}),
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  deleteMultiple(ids) {
    return httpService.post({
      url: `${inspectionUrl}/deleteInspections`,
      data: {
        guids: ids
      },
    });
  },

  /**
   * Get deletion impact analysis for one or more Inspection tags
   * @param {string[]} ids - Array of inspection tag IDs
   * @returns {Object} TagDeletionImpactVM with categories and counts
   */
  getDeletionImpact(ids) {
    return httpService.post({
      url: `${inspectionUrl}/deletionImpact`,
      data: { guids: ids },
    });
  },
};
